import { Galet } from '@app/catalog/products/equipement/complex/galet';

import { Phone } from '../../../catalog/products/equipement/complex/phone';
import { Product } from '../../../catalog/products/product';
import { Edp } from '../../../catalog/products/subscription/edp';
import { Fai } from '../../../catalog/products/subscription/plan/fai';
import { Faim } from '../../../catalog/products/subscription/plan/faim';
import { Ideo } from '../../../catalog/products/subscription/plan/premium/ideo';
import { Sensation } from '../../../catalog/products/subscription/plan/premium/sensation';
import { Simo } from '../../../catalog/products/subscription/plan/simo';
import { Sowo } from '../../../catalog/products/subscription/plan/sowo';
import { ProductContextBase } from '../../context/child/product-context.service';
import { AccessoryBase } from './equipement/accessory';
import { SimBase } from './equipement/sim';
import { JsonProduct } from './interface/context';
import { ServiceBase } from './service';
import { InsuranceBase } from './subscription/insurance';
import { OptionBase } from './subscription/option';

/**
 * The CatalogBase class
 * See {@link PhoneBase} to see how it is used
 */
export abstract class CatalogBase {
    /**
     * Instanciate the ProductBase
     * @param product json product
     * @param     context the context
     * @return             ProductBase object, PhoneBase | SowoBase...
     */
    public static getInstance(
        product: JsonProduct,
        productContextService: ProductContextBase,
        uniqueId: string = '',
    ): Product {
        let p: Product;
        if (!product.type_id) {
            throw new Error('cannot instanciate JsonProduct has not type_id');
        }

        switch (product.type_id) {
            case 'phone':
            case 'phone_simple':
                p = new Phone(product, uniqueId);
                break;
            case 'box':
                p = new Galet(product, uniqueId);
                break;
            case 'plan_simo':
            case 'plan_simo_renew':
            case 'plan_sowo':
            case 'plan_sowo_renew':
                if (
                    product.obligation &&
                    product.obligation_id !== 'none' &&
                    (product.type_id === 'plan_sowo' || product.type_id === 'plan_simo')
                ) {
                    p = new Simo(product, uniqueId);
                } else {
                    p = new Sowo(product, uniqueId);
                }
                break;
            case 'plan_ideo':
            case 'plan_ideo_renew':
            case 'plan_ideo_pro':
                p = new Ideo(product, uniqueId);
                break;
            case 'plan_premium':
            case 'plan_premium_renew':
                p = new Sensation(product, uniqueId);
                break;
            case 'faim':
            case 'faim_premium':
                p = new Faim(product, uniqueId);
                break;
            case 'fai':
            case 'faim_unlimited':
                p = new Fai(product, uniqueId);
                break;
            case 'accessory':
            case 'accessory_configurable':
                p = new AccessoryBase(product, uniqueId);
                break;
            case 'option_salable':
                p = new OptionBase(product, uniqueId);
                break;
            case 'insurance':
                p = new InsuranceBase(product, uniqueId);
                break;
            case 'sim':
                p = new SimBase(product, uniqueId);
                break;
            case 'edp':
                p = new Edp(product, uniqueId);
                break;
            case 'service_assistance':
            case 'service_accompaniment':
                p = new ServiceBase(product, uniqueId);
                break;
            default:
                throw new Error(product.type_id + ' not valid type_id');
        }

        p.context = productContextService;
        return p;
    }

    /**
     * to get the category name of the json product
     * @param product json product
     * @return              telephones|accessoires...
     */
    public static getCategoryName(product: JsonProduct): string {
        switch (product.type_id) {
            case 'phone':
            case 'phone_simple':
                return 'telephones';
            case 'accessory':
                return 'accessoires';
            default:
                return 'defaut';
        }
    }
}
